import { Collection, } from "@bluelibs/x-ui";
import { FollowUp } from "@root/api.types";
import { ClientRequestsCollection, UsersCollection, } from "@bundles/UIAppBundle/collections";
export class FollowUpsCollection extends Collection {
    getName() {
        return "FollowUps";
    }
    getInputs() {
        return {
            insert: "FollowUpInsertInput!",
            update: "FollowUpUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => ClientRequestsCollection,
                name: "clientRequest",
                field: "clientRequestId",
            },
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
